import { makeAutoObservable } from 'mobx';

export default class CompareStore {
    compareItems = [];

    constructor() {
        makeAutoObservable(this);
        this.setCompareItems();
    }

    setCompareItems() {
        const compareVehicles = JSON.parse(localStorage.getItem("compare-vehicles"));
        if (compareVehicles) {
            this.compareItems = compareVehicles;
        }
    }

    addItem(vehicle) {
        if (!this.compareItems.some(item => item.id === vehicle.id)) {
            this.compareItems.push({
                id: vehicle.id,
                name: `${vehicle?.brand} ${vehicle?.type}`,
                image: vehicle.image || null
            });
            this.syncToLocalStorage();
        }
    }

    removeItem(vehicleId) {
        this.compareItems = this.compareItems.filter(item => item.id !== vehicleId);
        this.syncToLocalStorage();
    }

    syncToLocalStorage() {
        window.localStorage.setItem("compare-vehicles", JSON.stringify(this.compareItems));
    }

    syncWithServerData(validIds) {
        this.compareItems = this.compareItems.filter(item => validIds.includes(item.id));
        this.syncToLocalStorage();
    }

    hasItem(vehicleId) {
        return this.compareItems.some(item => item.id === vehicleId);
    }
}
